import React, {  useEffect, useState,useRef,useContext  } from "react";
import ReactGA from 'react-ga4';
import { useNavigate,Link,useParams  } from 'react-router-dom';
import Lang from '../../../lang/translations';
import Context from '../../../context/context';
import queryString from 'query-string';
import helpersFunction from "../../../_helpers/helpersFunction";

import adyen_functions from "./functions";
const config = require("../../../_helpers/configServizi"); 




export default function Ok() {
    
    const query = queryString.parse(window.location.search);
    
    var redirectResult = query.redirectResult

    const context = useContext(Context)
    const navigate = useNavigate() 

     
    
    useEffect(() => {

        const domain = window.location.hostname
        
        adyen_functions.checkTransactionStatus({clickid:localStorage.getItem('trackerId'),redirectResult:redirectResult,domain :domain,payment_company : config.servizi[domain].payment_company})
            .then(response=>{
                if(!response.result){
                    navigate('/find')
                }
                const contenuto = helpersFunction.contenuto_popop_pagamento(response.message)
                helpersFunction.showPopupgenerico("blocked",context,contenuto)
                setTimeout(function(){ 
                    context.Socket.emit('chat', context.messaggioPending);
                    context.setMessaggioPending(null);
                    window.location.replace("/chats")  }, 4000);

            }).catch(err=>{
                const contenuto = helpersFunction.contenuto_popop_pagamento("generico")
                helpersFunction.showPopupgenerico("blocked",context,contenuto)
                console.log(err)
            })
           
      
       
     },[])
    

    return (<div className="all-container bg-light pianiAbbonamentoPage">
               
            </div>
    )
   


}